/* JavaScript for Header, Sidenav Drawer, and Mega Menus */
/* Handles hamburger toggle, mobile accordion, desktop hover, and modals */
/* Uses unique 'zkq-' classes for conflict avoidance */

document.addEventListener('DOMContentLoaded', () => {
  // Elements
  const hamburgerBtn = document.querySelector('.zkq-j5h7q9-hamburger');
  const drawer = document.querySelector('.zkq-f6x3m7-drawer');
  const overlay = document.querySelector('.zkq-t2r9w4-overlay');
  const closeBtn = document.querySelector('.zkq-l9t2w6-close');
  const menuItems = document.querySelectorAll('.zkq-b4n9t6-item, .zkq-h9k6v3-item, .zkq-q5t9n2-item');

  // Toggle Drawer
  const toggleDrawer = (show) => {
    drawer.style.display = 'block';
    overlay.style.display = 'block';
    setTimeout(() => {
      drawer.style.transform = show ? 'translateX(0)' : 'translateX(-100%)';
      overlay.style.opacity = show ? '1' : '0';
    }, 10);
    if (!show) {
      setTimeout(() => {
        drawer.style.display = 'none';
        overlay.style.display = 'none';
        // Close all submenus
        menuItems.forEach(item => {
          const submenu = item.querySelector('.zkq-w8t4m5-submenu, .zkq-t3n5k8-submenu, .zkq-b6p4t3-mega');
          if (submenu) {
            submenu.classList.remove('open');
            submenu.style.display = 'none';
            item.querySelector('.zkq-x2m7r8-header, .zkq-j4m8t2-header, .zkq-l3k7v5-header').setAttribute('aria-expanded', 'false');
          }
        });
      }, 300);
    }
  };

  // Event Listeners
  hamburgerBtn.addEventListener('click', () => toggleDrawer(true));
  closeBtn.addEventListener('click', () => toggleDrawer(false));
  overlay.addEventListener('click', (e) => {
    e.preventDefault();
    toggleDrawer(false);
  });

  // Mobile Accordion Logic
  if (window.innerWidth <= 767) {
    menuItems.forEach(item => {
      const toggle = item.querySelector('.zkq-k6v3p9-toggle, .zkq-p7r3w9-toggle, .zkq-r9w2m8-toggle');
      const submenu = item.querySelector('.zkq-w8t4m5-submenu, .zkq-t3n5k8-submenu, .zkq-b6p4t3-mega');
      const header = item.querySelector('.zkq-x2m7r8-header, .zkq-j4m8t2-header, .zkq-l3k7v5-header');
      if (toggle && submenu && header) {
        toggle.addEventListener('click', () => {
          // Close other submenus
          menuItems.forEach(otherItem => {
            const otherSubmenu = otherItem.querySelector('.zkq-w8t4m5-submenu, .zkq-t3n5k8-submenu, .zkq-b6p4t3-mega');
            const otherHeader = otherItem.querySelector('.zkq-x2m7r8-header, .zkq-j4m8t2-header, .zkq-l3k7v5-header');
            if (otherSubmenu && otherSubmenu !== submenu && otherHeader) {
              otherSubmenu.classList.remove('open');
              otherSubmenu.style.display = 'none';
              otherHeader.setAttribute('aria-expanded', 'false');
            }
          });
          // Toggle current submenu
          submenu.classList.toggle('open');
          submenu.style.display = submenu.classList.contains('open') ? 'block' : 'none';
          header.setAttribute('aria-expanded', submenu.classList.contains('open'));
        });
      }
    });
  }

  // Desktop Hover Logic
  if (window.innerWidth > 767) {
    const navItems = document.querySelectorAll('.zkq-g9k3v5-item, .zkq-q5t9n2-item');
    navItems.forEach(item => {
      const mega = item.querySelector('.zkq-h4m8t2-mega, .zkq-b6p4t3-mega, .zkq-h4m8t2-simple-dropdown');
      if (mega) {
        item.addEventListener('mouseenter', () => {
          mega.style.display = 'block';
          setTimeout(() => {
            mega.style.opacity = '1';
            mega.style.transform = 'translateY(0)';
          }, 10);
        });
        item.addEventListener('mouseleave', () => {
          mega.style.opacity = '0';
          mega.style.transform = 'translateY(-10px)';
          setTimeout(() => {
            mega.style.display = 'none';
          }, 200);
        });
      }
    });
  }

  // Keyboard Accessibility
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.style.display === 'block') {
      toggleDrawer(false);
    }
  });
});